import { useMemo } from 'react';
import { sortBy } from 'lodash-es';
import { SchedulerDayColumn } from '@lp/features/Scheduler/types';
import { getShiftSiblingsMap } from '@lp/features/Scheduler/utils';
import { getCCSiblingData } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/utils';
import { PCCOnCallResource } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/types';
import { CCResourcesWithShifts, CCShift, CCShiftType } from '@/api/apis/resources/schedule';

export const usePCCShiftSiblingsMap = (dayCols: SchedulerDayColumn[], myShifts?: Record<string, CCShift>) => {
  return useMemo(() => getShiftSiblingsMap(dayCols, myShifts, getCCSiblingData), [dayCols, myShifts]);
};

export const usePCCOnCallResourcesMap = (
  dayCols: SchedulerDayColumn[],
  shiftsData: CCResourcesWithShifts,
  resourceIds?: string[],
) => {
  return useMemo(() => {
    const onCallResourcesMap: Record<string, PCCOnCallResource[]> = {};

    dayCols.forEach((column) => {
      const segments = Object.values(shiftsData).filter((segment) => {
        const dayShift = segment.days[column.key];
        const hasId = !resourceIds?.length || resourceIds.includes(segment.resource.id);
        return hasId && !!segment.resource && dayShift?.shiftType === CCShiftType.OnCall;
      });

      const onCallResources = segments.map((segment) => {
        return { ...segment.resource, isManager: segment.days[column.key]?.isManager };
      });

      onCallResourcesMap[column.key] = sortBy(onCallResources, (r) => !r.isManager);
    });

    return onCallResourcesMap;
  }, [dayCols, resourceIds, shiftsData]);
};
